module.exports = __webpack_public_path__ + "static/media/assistant.09421116.png";